<template>
  <view
    :class="{
      'pft-radio': true,
      checked: checked,
    }"
    @click="switchStatus"
    :style="style"
  >
    <text
      :class="{
        iconfont: true,
        'icon-radiobuttonunselect': !checked,
        'icon-radiobuttonselect': checked,
      }"
    ></text>
    <slot></slot>
  </view>
</template>

<script setup lang="ts">
import { ref, getCurrentInstance, inject, watch } from "vue"

const instance = getCurrentInstance()

const props = withDefaults(
  defineProps<{
    value: string | number
    style?: { [key: string]: string }
  }>(),
  {
    value: () => "",
    style: () => ({}),
  },
)

// 获取父组件传递的值
const modelValue = inject("modelValue") as { modelValue: string | number }

const checked = ref(modelValue.modelValue === props.value)

// 监听父组件传递的值
watch(
  () => modelValue,
  val => {
    checked.value = val.modelValue === props.value
  },
  {
    immediate: true,
    deep: true,
  },
)

const switchStatus = () => {
  // 通知父组件
  instance?.parent?.exposed?.updateValue(props.value)
}
</script>
<style lang="scss">
.pft-radio {
  display: flex;
  align-items: center;
  padding: 5px 0;
  font-size: 14px;
  color: #fff;
  .iconfont {
    font-size: 16px;
    margin-right: 5px;
  }
  &.checked {
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
